// extracted by mini-css-extract-plugin
module.exports = {"stack":"OrderCells_stack__3SR3a","small":"OrderCells_small__1h2ox"};